import { useNavigate } from 'react-router-dom';

const Services = () => {
  const navigate = useNavigate();

  const services = [
    {
      title: 'Climatisation',
      description: 'Installation, entretien et dépannage de systèmes de climatisation pour votre confort toute l\'année',
      icon: 'ri-temp-cold-line',
      image: 'https://public.readdy.ai/ai/img_res/a23256ef353e05a544bc6cff604314da.jpg',
      link: '/services/climatisation'
    },
    {
      title: 'Chauffage',
      description: 'Installation et maintenance de chaudières, pompes à chaleur et systèmes de chauffage central',
      icon: 'ri-fire-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20heating%20boiler%20system%20installation%20professional%20technician%20working%20on%20wall%20mounted%20gas%20boiler%20clean%20white%20walls%20pipes%20and%20valves%20visible%20technical%20equipment%20bright%20lighting&width=400&height=300&seq=heating1&orientation=landscape',
      link: '/services/chauffage'
    },
    {
      title: 'Plomberie',
      description: 'Réparation de fuites, débouchage, installation de robinetterie et tous travaux de plomberie',
      icon: 'ri-drop-line',
      image: 'https://readdy.ai/api/search-image?query=professional%20plumber%20working%20on%20modern%20bathroom%20sink%20installation%20chrome%20faucet%20and%20pipes%20clean%20white%20bathroom%20bright%20lighting%20tools%20and%20equipment%20visible%20quality%20craftsmanship&width=400&height=300&seq=plumbing1&orientation=landscape',
      link: '/services/plomberie'
    },
    {
      title: 'Rénovation Salle de Bains',
      description: 'Conception et réalisation complète de votre salle de bains : douche, WC, carrelage, robinetterie',
      icon: 'ri-home-smile-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20bathroom%20renovation%20beautiful%20white%20tiles%20walk%20in%20shower%20glass%20partition%20chrome%20fixtures%20clean%20minimalist%20design%20bright%20natural%20lighting%20elegant%20contemporary%20style&width=400&height=300&seq=bathroom1&orientation=landscape',
      link: '/services/renovation-salle-de-bains'
    },
    {
      title: 'Dépannage Urgent',
      description: 'Intervention rapide 7j/7 pour tous vos problèmes de plomberie et chauffage',
      icon: 'ri-alarm-warning-line',
      image: 'https://readdy.ai/api/search-image?query=emergency%20plumbing%20service%20professional%20technician%20with%20tools%20and%20equipment%20ready%20for%20urgent%20repair%20work%20service%20van%20in%20background%20bright%20daylight%20professional%20uniform&width=400&height=300&seq=emergency1&orientation=landscape',
      link: '/services/depannage-urgent'
    },
    {
      title: 'Entretien',
      description: 'Entretien annuel obligatoire de vos installations pour garantir performance et sécurité',
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=professional%20maintenance%20service%20technician%20inspecting%20heating%20system%20with%20checklist%20and%20tools%20annual%20maintenance%20work%20clean%20technical%20room%20bright%20lighting%20quality%20service&width=400&height=300&seq=maintenance1&orientation=landscape',
      link: '/services/entretien'
    }
  ];

  const handleServiceClick = (link: string) => {
    navigate(link);
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Nos <strong>Services</strong> à Valence
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-2">
            Plombier chauffagiste professionnel à votre service pour tous vos besoins en installation, dépannage et entretien
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              onClick={() => handleServiceClick(service.link)}
              className="group bg-gray-50 rounded-xl overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                  <i className={`${service.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
